"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionSpy = exports.Section = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Section = function Section(_ref) {
  var name = _ref.name,
    title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("section", null, /*#__PURE__*/_react["default"].createElement("a", {
    name: name,
    href: "#".concat(name)
  }, title ? title : name), children);
};
exports.Section = Section;
var SectionSpy = function SectionSpy(_ref2) {
  var render = _ref2.render;
  return render({});
};
exports.SectionSpy = SectionSpy;
if (typeof window !== 'undefined') {
  var SmartSections = require('react-smart-sections');
  exports.SectionSpy = SectionSpy = SmartSections.SectionSpy;
  exports.Section = Section = SmartSections.Section;
}